@if (category) {
<div class="product-modal-backdrop" (click)="close()">
  <div class="product-modal" (click)="$event.stopPropagation()">
    <!-- HEADER -->
    <header class="modal-header">
      <div class="header-content">
        <div class="eyebrow">
          <span></span>
          {{ category.shortTitle }}
        </div>
        <h1>
          {{ category.title }}
        </h1>
        <p>
          {{ category.description }}
        </p>
      </div>
      <button type="button" class="close-button" (click)="close()" aria-label="Close">
        ×
      </button>
    </header>
    <!-- PRODUCTS -->
    <section class="products-section">
      <div class="products-grid">
        @for (
        product of category.products;
        track product.id
        ) {
        <article class="product-card">
          <!-- IMAGE -->
          <div class="product-image">
            <img [src]="product.image" [alt]="product.name" loading="lazy">
          </div>
          <!-- CONTENT -->
          <div class="product-content">
            <!-- <div class="product-top">
              <span class="product-number">
                {{ ($index + 1).toString().padStart(2, '0') }}
              </span>
            </div> -->
            <h2>
              {{ product.name }}
            </h2>
            @if (product.types?.length) {
<div class="product-types">
    @for (type of product.types; track type) {
<div class="product-type-card">
<span class="type-dot"></span>
<span class="type-name">{{ type }}</span>
</div>
    }
</div>
}
            <p>
              {{ product.shortDescription }}
            </p>
            @if (product.applications?.length) {
            <div class="applications">
              @for (
              application of product.applications;
              track application
              ) {
              <span>
                {{ application }}
              </span>
              }
            </div>
            }
          </div>
        </article>
        }
      </div>
    </section>
    <!-- FOOTER -->
    <footer class="modal-footer">
      <div class="footer-brand">
        <span>
          MAIZE TRADING FZC
        </span>
        <small>
          Sowing Trust, Reaping Success
        </small>
      </div>
      <button type="button" class="footer-close" (click)="close()">
        Close
        <span>×</span>
      </button>
    </footer>
  </div>
</div>
}